var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"empty-items-wrapper"},[_c('inline-svg',{attrs:{"fill":"currentColor","height":"100","src":require('@/assets/img/img_helper_empty.svg')}}),_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.message))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }